'use client';

import { useTranslations } from 'next-intl';
import React, { FC } from 'react';

import { useStyleContext, TAiVideo } from '@/src/providers';

import { CloseAppButton } from './CloseAppButton';
import { GenerateButton } from './GenerateButton';
import { GetButton } from './GetButton';
import { UploadButton } from './UploadButton';

interface ButtonsGroupProps {
  disabled: boolean;
  handleClickGenerate: () => Promise<void>;
  handleFileChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  videoStyleImage: File | File[] | null;
  effectPrompt: string;
  effectAccessory: string;
  storyLinesLength?: number;
  onClickUploadButton?: () => void;
}

export const ButtonsGroup: FC<ButtonsGroupProps> = ({
  disabled,
  handleClickGenerate,
  handleFileChange,
  videoStyleImage,
  effectPrompt,
  effectAccessory,
  onClickUploadButton,
  storyLinesLength,
}) => {
  const {
    activeStyle,
    filteredAvatars,
    isAvatarExist,
    isYourPhoto,
    isPhotosessionPhoto,
  } = useStyleContext();

  const t = useTranslations('imageModal');

  return (
    <>
      {['VideoLook', 'VideoStyle'].includes(activeStyle?.__typename!) ? (
        isYourPhoto ? (
          !videoStyleImage ? (
            <UploadButton
              disabled={disabled}
              isMultiple={false}
              buttonText={t('buttonUploadPhoto')}
              onChange={handleFileChange}
              onClick={onClickUploadButton}
            />
          ) : !filteredAvatars.length &&
            !(activeStyle as TAiVideo).videoStyleId ? (
            <CloseAppButton text={t('buttonAvatar')} keybord="createAvatar" />
          ) : (
            <GenerateButton disabled={disabled} onClick={handleClickGenerate} />
          )
        ) : (
          <GenerateButton
            disabled={disabled || !isAvatarExist}
            onClick={handleClickGenerate}
          />
        )
      ) : activeStyle?.__typename === 'Effect' ? (
        !(videoStyleImage as File[])?.length ? (
          activeStyle.isFreeStickerPack ? (
            <GetButton
              buttonText={t('buttonFreeStickers')}
              disabled={false}
              onClick={handleClickGenerate}
            />
          ) : (
            <UploadButton
              disabled={disabled}
              isMultiple={activeStyle?.requiredImageCount === 2}
              buttonText={t('buttonUploadPhoto')}
              onChange={handleFileChange}
              onClick={onClickUploadButton}
            />
          )
        ) : (
          <GenerateButton
            disabled={
              disabled ||
              (activeStyle?.isInputUserName && !effectPrompt) ||
              (activeStyle?.isInputAccessory && !effectAccessory)
            }
            onClick={handleClickGenerate}
          />
        )
      ) : isPhotosessionPhoto ? (
        !videoStyleImage ? (
          <UploadButton
            disabled={disabled}
            isMultiple={false}
            buttonText={t('buttonUploadPhoto')}
            onChange={handleFileChange}
            onClick={onClickUploadButton}
          />
        ) : (
          <GenerateButton disabled={disabled} onClick={handleClickGenerate} />
        )
      ) : activeStyle?.__typename === 'CombiVideo' ? (
        filteredAvatars.length ? (
          !videoStyleImage ? (
            <UploadButton
              disabled={disabled || !isAvatarExist}
              isMultiple={false}
              buttonText={t('buttonUploadPartnerPhoto')}
              onChange={handleFileChange}
              onClick={onClickUploadButton}
            />
          ) : (
            <GenerateButton
              disabled={disabled || !isAvatarExist}
              onClick={handleClickGenerate}
            />
          )
        ) : (
          <CloseAppButton text={t('buttonAvatar')} keybord="createAvatar" />
        )
      ) : activeStyle?.__typename === 'VideoVeo3' ? (
        <GenerateButton
          disabled={disabled || !effectPrompt}
          onClick={handleClickGenerate}
        />
      ) : activeStyle?.__typename === 'StoryLine' ? (
        !videoStyleImage ? (
          <UploadButton
            disabled={disabled}
            isMultiple={false}
            buttonText={t('buttonUploadPhoto')}
            onChange={handleFileChange}
            onClick={onClickUploadButton}
          />
        ) : (
          <GenerateButton
            disabled={disabled}
            onClick={handleClickGenerate}
            storyLinesLength={storyLinesLength}
          />
        )
      ) : filteredAvatars.length ? (
        <GenerateButton
          disabled={disabled || !isAvatarExist}
          onClick={handleClickGenerate}
        />
      ) : (
        <CloseAppButton text={t('buttonAvatar')} keybord="createAvatar" />
      )}
    </>
  );
};
